import React from 'react';
import {
  withMeta,
  withSystem,
  Plugins,
  Atom,
  AtomRenderProps,
} from '@packages/systems/wfdl';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {
  TText,
  TRecord,
  TTypeReference,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';

const SearchInput = Atom.createRender(
  ({attributes, classes, generateAttributes, context}: AtomRenderProps) => {
    const inputClasses = classes.push('w-input');
    const props = {
      ...generateAttributes(attributes, inputClasses),
      defaultValue: context.get('query'),
    } as const;
    return <input {...props} />;
  }
);

const config = createDevlinkAtom({
  displayName: 'Search Input',
  constraints: {
    ancestors: [
      {
        is: ['SearchForm'],
        name: 'Form',
        rule: 'ExactlyOne',
      },
    ],
  },
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: SearchInput,
  fields: {
    attr: withSystem(
      {private: false},
      TRecord(
        {
          placeholder: withMeta(
            {
              placeholder: 'E.g. Search…',
            },
            withSystem(
              {
                label: 'Placeholder',
                isFullWidth: true,
                isLocalizable: true,
              },
              TText
            )
          ),
          autofocus: withMeta(
            {
              labels: {
                true: 'On',
                false: 'Off',
              },
            },
            withSystem(
              {
                label: 'Autofocus',
                isFullWidth: true,
                isLocalizable: true,
              },
              TTypeConstructor(
                qualify(Plugins.name('Basic'), typeName('LabeledBoolean'))
              )
            )
          ),
        },
        TTypeReference('extraAttrs')
      )
    ),
    search: withSystem({private: true}, TRecord({type: TText})),
  },
});

export default config;
